import {setAppType} from 'utils/appTypeState';
setAppType('default');
